import NetworkBarGroupLink from './NetworkBarGroupLink';
import NetworkBarGroupLinkContainer from './NetworkBarGroupLink.container';
export default NetworkBarGroupLinkContainer(NetworkBarGroupLink);

//# sourceMappingURL=index.js.map